import { createApi, useAuth } from '@kts/client';
import { currentLocale } from '@kts/i18n';

/** Veb-ilova API klienti: shu domen (`/api` Vite proxy yoki nginx orqali), refresh — cookie. */
export const api = createApi({
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  client: 'web',
  locale: currentLocale,
  onAuthLost: () => useAuth.getState().lost(),
});
